"use strict";
var _a, _b;
__webpack_public_path__ = `${(_b = (_a = document.getElementById('BXP_CONTENT_STATIC_BASE_URL')) === null || _a === void 0 ? void 0 : _a.innerHTML) !== null && _b !== void 0 ? _b : ''}/`;
//# sourceMappingURL=public-path.js.map